import { SharelockApi } from 'sl-sdk';

import { getStoredJwt } from 'auth/storage';

function requireEnv(
  name: 'VITE_MAIN_API_URL' | 'VITE_LOCK_API_URL' | 'VITE_INSURANCE_API_URL' | 'VITE_DASHBOARD_URL'
): string {
  const value = import.meta.env[name]?.trim();
  if (value) {
    return value;
  }
  if (import.meta.env.DEV) {
    if (name === 'VITE_DASHBOARD_URL') {
      return 'http://localhost:3000';
    }
    return 'http://localhost:8080';
  }
  throw new Error(`MISSING_${name}`);
}

const apiUrls = {
  main: requireEnv('VITE_MAIN_API_URL'),
  lock: requireEnv('VITE_LOCK_API_URL'),
  insurance: requireEnv('VITE_INSURANCE_API_URL'),
};

void SharelockApi.initialize(apiUrls, () => Promise.resolve(getStoredJwt()), 'ZENDESK', false);

export const dashboardBaseUrl = requireEnv('VITE_DASHBOARD_URL').replace(/\/$/, '');

export { SharelockApi };
